import { useSyncExternalStore } from 'react'
import { cookieYesConsentService } from '@core/services/cookie-consent/cookieyes-consent-service'

const getServerSnapshot = () => false

export function useAnalyticsConsent() {
  return useSyncExternalStore(
    (onStoreChange) => cookieYesConsentService.subscribe(onStoreChange),
    () => cookieYesConsentService.isAnalyticsConsentGranted(),
    getServerSnapshot,
  )
}
